/**
 * 本番として扱う公開ホスト名の判定(2026-10-08)。
 * 本番の配信元を Cloudflare の Git 連携プロジェクトへ移すため、旧URLと新URLの両方を本番と判断する。
 * - 新しいURLが決まったら PRODUCTION_HOSTS に足す(または ビルド時の VITE_PRODUCTION_HOSTS にカンマ区切りで指定)
 * - 本番以外の *.pages.dev(ブランチのプレビュー等)は「プレビュー」として、ログインをタブ単位にし、
 *   本番の Firestore((default))には繋げない(firebase.ts)
 */
export const PRODUCTION_HOSTS: readonly string[] = [
  'cc-system.pages.dev', // 旧URL(直接アップロード方式。移行後は新URLへ転送する)
  'cc-system-app.pages.dev', // 新URL(2026-10-08 作成。Cloudflare の Git 連携で main を配信)
];

export function productionHosts(extra?: string): string[] {
  const fromEnv = (extra ?? '')
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);
  return [...PRODUCTION_HOSTS, ...fromEnv];
}

export function isProductionHost(host: string, extra?: string): boolean {
  return productionHosts(extra).includes(host.toLowerCase());
}

/** 本番以外の *.pages.dev(ブランチごとのプレビュー・テスト環境) */
export function isPreviewHost(host: string, extra?: string): boolean {
  const h = host.toLowerCase();
  return h.endsWith('.pages.dev') && !isProductionHost(h, extra);
}
